const userDownloadCCPlatform = 'verizon_customer_case_v2024';

export { userDownloadCCPlatform };
